import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import flightIcon from "../../_theme/_assets/images/flightIcon.svg";
import ThreeDots from "../../_theme/_assets/images/3 dots button.svg";
import TwoDots from "../../_theme/_assets/images/2 dots button.svg";
import Greendot from "../../_theme/_assets/images/Green dot button.svg";
import Yellowdot from "../../_theme/_assets/images/Yellow dot button.svg";
import bluedot  from "../../_theme/_assets/images/blue dot button.svg";
import moment from 'moment';
import SpinnerLoader from '../../pages/bookingConfirmation/Utils/spinner';
import { getFlightLogo } from '../../pages/bookingConfirmation/Utils/CommenFunction';
import usePagination from '../../comman/pagination';
import { Pagination } from '@material-ui/lab';
import { Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useDispatch ,useSelector } from "react-redux";
import { setCheckBoxObject, setTarifDetail, setClassData, setSelectedTarifData, setPrixDetails, setTariffKeys, setClassKeys, setPrixKeys, updateSearchRequest } from '../AppStore/ActionCreator/commonDataAction';
import { getOneTarif } from '../thunks/getOneTarif';
import { getClassData } from '../thunks/getClassData';
import { getOnePrix } from '../thunks/getOnePrix';
import { parseISO, format } from 'date-fns'
import swal from 'sweetalert';
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle, DialogContent } from '@material-ui/core';
import CustomDateInput from '../../components/common components/CustomDateInput';
import { getDuplicate } from '../../pages/bookingConfirmation/thunks/getDuplicate';
import Swal from 'sweetalert2';

export default function ContractListResult(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const responseTarifs = props?.responseTarifs
    let localResponseTarifs = [...responseTarifs]
    // const [expanded, setExpanded] = useState([]);
    // const handleExpandAll = () => {
    //     setExpanded([1, 2, 3]); // Assuming you have three accordions with ids 1, 2, and 3
    // };
    // const [tarif, setTarif] = useState([...props?.responseTarifs])
    const tarif = [...props?.responseTarifs]
    const [checkBoxObject, setCheckBoxObjectlocal] = useState({"tarifs":[],"classes":[],"prixs":[], blackOutCarrier: {}, blackoutDate: {}, blackoutDay: {}, tourCode: {}});
    const [bulkUpdate, setBulkUpdate] = useState(true);
    
    const [bulkDuplicate, setBulkDuplicate] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    let [page, setPage] = useState(1);
    let [allTarifClassesPrixs, setAllTarifClassesPrixs] = useState([]);
    const [classes, setClasses] = useState(false);
    const [exapandAllView, setExapandAllView] = useState(false)
    const [exapandAllViewLabel, setExapandAllViewLabel] = useState("Expand All")
    const [mainAcc, setMainAcc] = useState("")
    const [tarifKeys, setTarifKeys] = useState([])
    const [classKeys, setClassKey] = useState([])
    const [secAcc, setSecAcc] = useState("")
    const [prixKeys, setPrixKey] = useState([])
    const [prixBlackOutCarrier, setPrixBlackOutCarrier] = useState({})
    const [prixBlackoutDays, setPrixBlackoutDays] = useState({})
    const [prixTourCodes, setPrixTourCodes] = useState({})
    const [prixBlackoutDates, setPrixBlackoutDates] = useState({})
    const [pageSize, setPageSize] = useState(100);
    const paginationData = usePagination(tarif, pageSize);
    const count = Math.ceil(tarif.length / pageSize);
    const classData = useSelector((state) => state.commonDataReducer.classData);
    const allData = useSelector((state) => state.commonDataReducer);
    const { searchRequest } = allData;
    const { viewValue } = searchRequest;
    const [originValue, setOriginValue] = useState("");
    const [destinationValue, setDestinationValue] = useState("");
    const [validFrom, setValidFrom] = useState("");
    const [validTo, setValidTo] = useState("");
    const [loader, setLoader] = useState(false)

    useEffect(()=>{
        setCheckBoxObjectlocal({"tarifs":[],"classes":[],"prixs":[], blackOutCarrier: {}, blackoutDate: {}, blackoutDay: {}, tourCode: {}});
        if(!bulkDuplicate){
            setBulkUpdate(true)
        }
        setPage(1)
        let tarifs = []
        let classes = []
        let prixs = []
        let blackOutCarrier = {};
        let blackoutDate = {};
        let blackoutDay = {};
        let tourCode = {};
        
        props?.responseTarifs.map((tarif)=>{
            tarifs.push(tarif?.tarifKey);
            tarif?.classes.map((classData)=>{
                classes.push(classData?.clasKey)
                classData?.prix.map((prix)=>{
                    prixs.push(prix?.prixKey)
                    if(prix.prixKey && !blackOutCarrier[prix.prixKey]){
                        blackOutCarrier[prix?.prixKey] = prix?.blackOutCarrier || [];
                    }
                    if(prix.prixKey && !blackoutDate[prix.prixKey]){
                        blackoutDate[prix?.prixKey] = prix?.blackoutDate || [];
                    }
                    if(prix.prixKey && !blackoutDay[prix.prixKey]){
                        blackoutDay[prix?.prixKey] = prix?.blackoutDay || [];
                    }
                    if(prix.prixKey && !tourCode[prix.prixKey]){
                        tourCode[prix?.prixKey] = prix?.tourCode || [];
                    }
                })
            }) 
        })
            if(props?.viewResultAsClass){
                setExpanded([...tarifs])
                setInnExpanded([])
            }
            else if(props?.viewResultAsPrix){
                setExpanded([...tarifs])
                setInnExpanded([...classes])
            }else{
                setExpanded([])
                setInnExpanded([])
            }
        setTarifKeys([...tarifs])
        setClassKey([...classes])
        setPrixKey([...prixs])
        setPrixBlackOutCarrier(blackOutCarrier)
        setPrixBlackoutDates(blackoutDate)
        setPrixBlackoutDays(blackoutDay)
        setPrixTourCodes(tourCode)
        dispatch(setTariffKeys([...tarifs]))
        dispatch(setClassKeys([...classes]))
        dispatch(setPrixKeys([...prixs]))
    },[props?.responseTarifs, props?.viewResultAsPrix, props?.viewResultAsClass])

    const handleBulkUpdate = (flag) => {
        bulkUpdate && setBulkUpdate(!bulkUpdate);
    };
    const getOriginDestination = (originDestination = "") => {
        const arr = originDestination.split(",");
        let addEllipsis = false;
        if(arr.length > 3){
            arr.length = 3;
            addEllipsis = true;
        }
        const returnValue =  arr.join(",");
        return addEllipsis ? `${returnValue}...` : returnValue;
    }

    const handleExpandAll = () => {
        if (exapandAllView) {
            setExpanded([]);
            setInnExpanded([]);
            setExapandAllView(false);
            setExapandAllViewLabel("Expand All");
        } else {
            setExpanded([...tarifKeys]);
            setInnExpanded([...classKeys]);
            setExapandAllView(true);
            setExapandAllViewLabel("Collapse All");
        }
    };
    

    //Pagination 
    // const pageSize = 10;
    // const count = Math.ceil(tarif.length / pageSize);
    // const _DATA = usePagination(tarif, pageSize);
    // const handleChange = (e, p) => {
    //     setPage(p);
    //     _DATA.jump(p);
    //   };
    // const handleAccordionChange = (panel) => (event, isExpanded) => {
    //     setExpanded(isExpanded ? [...expanded, panel] : expanded.filter((item) => item !== panel));
    //   };

    // note : this is for future scope where the only the data present on the present page will be expanded as per the option selected in view result as
    // useEffect(()=>{
    //     let tarifs = []
    //     let classes = []
    //     let prixs = []
    //     _DATA.currentData().map((tarif)=>{
    //         tarifs.push(tarif?.tarifKey);
    //         tarif?.classes.map((classData)=>{
    //             classes.push(classData?.clasKey)
    //             classData?.prix.map((prix)=>{
    //                 prixs.push(prix?.prixKey)
    //             })
    //         }) 
    //     })
    //     if(props?.viewResultAsClass){
    //         setExpanded([...tarifs])
    //         setInnExpanded([])
    //     }
    //     else if(props?.viewResultAsPrix){
    //         setExpanded([...tarifs])
    //         setInnExpanded([...classes])
    //     }else{
    //         setExpanded([])
    //         setInnExpanded([])
    //     }
    // },[_DATA.currentData()])

    useEffect(() => {
        if (paginationData && page > 0) {
            paginationData.jump(page);
        }
    }, [page, paginationData]);

    // Reset to page 1 when page size changes
    useEffect(() => {
        setPage(1);
    }, [pageSize]);

    const handleChange = (event, newPage) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
    };

    const handleChangeCheckbox = (e, type, obj) => {
        const { name, checked } = e.target;
        let localCheckBox = {...checkBoxObject}
        if (name == "allSelect") {
            if(checked){
                if(!props?.viewResultAsPrix && !props?.viewResultAsClass){
                    localCheckBox['tarifs'] = [...tarifKeys]
                    // localCheckBox['classes'] = [...classKeys]
                    // localCheckBox['prixs'] = [...prixKeys]
                }
                if(props?.viewResultAsPrix){
                    localCheckBox['prixs'] = [...prixKeys]
                    localCheckBox['blackOutCarrier'] = {...prixBlackOutCarrier}
                }
                if(props?.viewResultAsClass){
                    localCheckBox['classes'] = [...classKeys]
                    localCheckBox['prixs'] = [...prixKeys]
                    localCheckBox['blackOutCarrier'] = {...prixBlackOutCarrier}

                }
            }
            else{
                localCheckBox['tarifs'] = []
                localCheckBox['classes'] = []
                localCheckBox['prixs'] = []
                localCheckBox['blackOutCarrier'] = {}
            }
        } else {
            if(checked){
                if(type == "tarif"){
                    if(bulkDuplicate){
                        if(viewValue === "tarif" && localCheckBox['tarifs'].length > 0){
                            swal({
                                title: "Warning",
                                text: "You can only select one tariff for duplication.",
                                icon: "warning",
                                button: "OK",
                            })
                        }else{
                            localCheckBox['tarifs'].push(name)
                        }

                    }else{
                        localCheckBox['tarifs'].push(name)
                    }
                    // let classesLocal = obj?.classes?.map((classVal)=>{return classVal?.clasKey})
                    // localCheckBox['classes'] = [...localCheckBox['classes'],...classesLocal]
                    // let prixLocal = obj?.classes?.map((classVal)=>{return classVal?.prix[0]?.prixKey})
                    // localCheckBox['prixs'] = [...localCheckBox['prixs'],...prixLocal]
                }

                if(type == "class"){
                    localCheckBox['classes'].push(name)
                    if(!bulkDuplicate){
                        const prixLocal = obj?.prix[0] ? obj?.prix[0]?.prixKey : "";
                        localCheckBox['prixs'].push(prixLocal)
                        if (prixLocal && !localCheckBox['blackOutCarrier']?.[prixLocal]) {
                            localCheckBox['blackOutCarrier'][prixLocal] = prixBlackOutCarrier[prixLocal];
                        }
                        if (prixLocal && !localCheckBox['blackoutDate']?.[prixLocal]) {
                            localCheckBox['blackoutDate'][prixLocal] = prixBlackoutDates[prixLocal];
                        }
                        if (prixLocal && !localCheckBox['blackoutDay']?.[prixLocal]) {
                            localCheckBox['blackoutDay'][prixLocal] = prixBlackoutDays[prixLocal];
                        }
                        if (prixLocal && !localCheckBox['tourCode']?.[prixLocal]) {
                            localCheckBox['tourCode'][prixLocal] = prixTourCodes[prixLocal];
                        }
                        
                    }
                }
                if(type == "prix"){
                    if(bulkDuplicate){
                        if(viewValue === "prix" && localCheckBox['prixs'].length > 0){
                            swal({
                                title: "Warning",
                                text: "You can only select one prix for duplication.",
                                icon: "warning",
                                button: "OK",
                            })
                        }else{
                            localCheckBox['prixs'].push(name)
                        }

                    }else{
                        localCheckBox['prixs'].push(name)
                        if(name && !localCheckBox['blackOutCarrier'][name]){
                           localCheckBox['blackOutCarrier'][name] = prixBlackOutCarrier[name];
                        }
                        if(name && !localCheckBox['blackoutDate']?.[name] && prixBlackoutDates[name] && prixBlackoutDates[name].length > 0){
                            localCheckBox['blackoutDate'][name] = prixBlackoutDates[name];
                        }
                        if(name && !localCheckBox['blackoutDay']?.[name] && prixBlackoutDays[name] && prixBlackoutDays[name].length > 0){
                            localCheckBox['blackoutDay'][name] = prixBlackoutDays[name];
                        }
                        if(name && !localCheckBox['tourCode']?.[name] && prixTourCodes[name] && prixTourCodes[name].length > 0){
                            localCheckBox['tourCode'][name] = prixTourCodes[name];
                        }
                    }
                }
            }
            else{
                if(type == "tarif"){
                    const index = localCheckBox['tarifs'].indexOf(name);
                    localCheckBox['tarifs'].splice(index, 1);
                    // let classesLocal = obj?.classes?.map((classVal)=>{return classVal?.clasKey})
                    // let tempClasses = removeSubset(localCheckBox['classes'],classesLocal)
                    // localCheckBox['classes'] = tempClasses
                    // let prixLocal = obj?.classes?.map((classVal)=>{return classVal?.prix[0]?.prixKey})
                    // let tempPrixs = removeSubset(localCheckBox['prixs'],prixLocal)
                    // localCheckBox['prixs'] = tempPrixs
                }
                if(type == "class"){
                    const index = localCheckBox['classes'].indexOf(name);
                    localCheckBox['classes'].splice(index, 1);
                    const indexPrix = localCheckBox['prixs'].indexOf(obj?.prix[0] ? obj?.prix[0]?.prixKey : "");
                    localCheckBox['prixs'].splice(indexPrix, 1);
                    const prixLocal = obj?.prix[0] ? obj?.prix[0]?.prixKey : "";
                    if(prixLocal && !localCheckBox['blackOutCarrier'][prixLocal]){
                        localCheckBox['blackOutCarrier'][prixLocal] = prixBlackOutCarrier[prixLocal];
                    }

                }
                if(type == "prix"){
                    const index = localCheckBox['prixs'].indexOf(name);
                    localCheckBox['prixs'].splice(index, 1);
                    if(name && !localCheckBox['blackOutCarrier'][name]){
                        localCheckBox['blackOutCarrier'][name] = prixBlackOutCarrier[name];
                    }
                }
            }
          
        }
        setCheckBoxObjectlocal({...localCheckBox})
        
      };
      function removeSubset(arr, subset) {
        const exclude = [...subset];
        return arr.filter(x => {
          const idx = exclude.indexOf(x);
          if (idx >= 0) {
            exclude.splice(idx, 1);
            return false;
          }
          return true;
        });
      }

      const bulkUpdateForm = () => {
        dispatch(setCheckBoxObject(checkBoxObject))
        if(bulkDuplicate){
            if(viewValue === "tarif"){
                if(checkBoxObject['tarifs'].length == 0){
                    swal({
                        title: "Warning",
                        text: "Please select atleast 1 tariff for duplication.",
                        icon: "warning",
                        button: "OK",
                    })
                }else{
                    setShowDialog(true)
                }
            }else if(viewValue === "class"){
                if(checkBoxObject['classes'].length == 0){
                    swal({
                        title: "Warning",
                        text: "Please select atleast 1 class for duplication.",
                        icon: "warning",
                        button: "OK",
                    })
                }
                else if(checkBoxObject['tarifs'].length == 0){
                    swal({
                        title: "Warning",
                        text: "Please select atleast 1 tariff to duplicate into.",
                        icon: "warning",
                        button: "OK",
                    })
                }
                else{
                    setShowDialog(true)
                }


            }else if(viewValue === "prix"){
                if(checkBoxObject['prixs'].length == 0){
                    swal({
                        title: "Warning",
                        text: "Please select atleast 1 prix for duplication.",
                        icon: "warning",
                        button: "OK",
                    })
                }
                else if(checkBoxObject['classes'].length == 0){
                    swal({
                        title: "Warning",
                        text: "Please select atleast 1 class to duplicate into.",
                        icon: "warning",
                        button: "OK",
                    })
                }
                else{
                    setShowDialog(true)
                }

            }
            
        }else{
            history.push("/bulkUpdate");
        }
      }

      const cancelBulkUpdate = () => {
        setBulkUpdate(true)
        setBulkDuplicate(false);
        setCheckBoxObjectlocal({"tarifs":[],"classes":[],"prixs":[]})
        if(showDialog){
            setShowDialog(false);
        }
      }

    const onClickTarifDetails = async (tarifKey) => {
        // const tarifDetails = await getOneTarif(tarifKey)
        // if (tarifDetails?.data) {
            // dispatch(setTarifDetail(tarifDetails?.data))
            window.open(`/newTariff?tariff=${tarifKey}`, "_blank");
        // }
    }

    const openClass = async (id, tarif) => {
        // let res = await getClassData(id?.clasKey)
        // let tarifData = { ...id, ...tarif }
        // dispatch(setSelectedTarifData(tarifData))
        // dispatch(setTarifDetail(tarifData))
        // dispatch(setClassData(res))
        // history.push("/newClass")
        window.open(`/newClass?tariff=${tarif?.tarifKey}+&class=${id?.clasKey}`, "_blank");
    }
    const [expanded, setExpanded] = React.useState([]);

    const prixDetailsOnclick = async (prixKey, classValue, tarifValue) => {
        // let classDetails = await getClassData(classValue?.clasKey);
        // dispatch(setClassData(classDetails))
        // let tarifData = { ...classValue, ...tarifValue }
        // dispatch(setSelectedTarifData(tarifData))
        // dispatch(setTarifDetail(tarifData))
        // const prixDetails = await getOnePrix(prixKey)
        // dispatch(setPrixDetails(prixDetails?.data))
        // history.push(`/newPrix?tariff=${tarifValue?.tarifKey}+&class=${classValue?.clasKey}+&prix=${prixKey}`)
        window.open(`/newPrix?tariff=${tarifValue?.tarifKey}+&class=${classValue?.clasKey}+&prix=${prixKey}`, "_blank");
    }

    const toggleAccordion = (index) => {
        setClasses(true)

        setExpanded((prevExpanded) => {
            const newExpanded = [...prevExpanded];
            const indexToRemove = newExpanded.indexOf(index);
            if (indexToRemove !== -1) {
                newExpanded.splice(indexToRemove, 1);
            } else {
                newExpanded.push(index);
            }
            return newExpanded;
        });
    };
    
    const handleIconClick = (index) => (e) => {
        e.stopPropagation();
        toggleAccordion(index);
    };
    const [innExpanded, setInnExpanded] = React.useState([]);

    const toggleInnAccordion = (index) => {
        setInnExpanded((prevExpanded) => {
            const newExpanded = [...prevExpanded];
            const indexToRemove = newExpanded.indexOf(index);
            if (indexToRemove !== -1) {
                newExpanded.splice(indexToRemove, 1);
            } else {
                newExpanded.push(index);
            }
            return newExpanded;
        });
    };
    
    const handleInnIconClick = (index) => (e) => {
        e.stopPropagation();
        toggleInnAccordion(index);
    };

    const handleDuplicate=(type)=>{
        setBulkDuplicate(true);
        if(type === "tariff"){
            dispatch(updateSearchRequest("viewValue", "tarif"));
            setBulkUpdate(false);
        }else if(type === "class"){
            dispatch(updateSearchRequest("viewValue", "class"));
            setBulkUpdate(false);
        }else if(type === "prix"){
            dispatch(updateSearchRequest("viewValue", "prix"));
            setBulkUpdate(false);
        }
    }

    const handleBulkDuplicate = async () => {
        if (loader) return;
        let payload;
        setLoader(true);
        if(viewValue === "tarif"){
            payload = {
                "origins": originValue != "" ? originValue : undefined,
                "destinations": destinationValue != "" ? destinationValue : undefined,
                "tariffKeys": checkBoxObject['tarifs']
            }
        }
        else if(viewValue === "class"){
            payload = {
                "tariffKeys": checkBoxObject['tarifs'],
                "classKeys": checkBoxObject['classes']
            }
        }
        else if(viewValue === "prix"){
            payload = {
                "validFrom": validFrom != "" ? validFrom : undefined,
                "validTo": validTo != "" ? validTo : undefined,
                "classKeys": checkBoxObject['classes'],
                "prixKeys": checkBoxObject['prixs']
            }
        }

        let response = await getDuplicate(payload);
        if (response?.status === "Success") {
            const tariffs = (viewValue === "tarif" && response.createdTarifs) ? response.createdTarifs : [];
            const classes = (viewValue === "class" && response.createdClasses) ? response.createdClasses : [];
            const prixes = (viewValue === "prix" && response.createdPrix) ? response.createdPrix : [];

            // Generate dynamic HTML links with headings
            const tariffLinks = tariffs.length
                ? `<h3>Tariffs</h3>${tariffs.map(id =>
                    `<p><button class="swal-tariff-btn" data-id="${id}">Tariff: ${id}</button></p>`
                ).join('')}`
                : '';

              // Classes as buttons that trigger JS function
            const classLinks = classes.length
                ? `<h3>Classes</h3>${classes.map(id =>
                    `<p><button class="swal-class-btn" data-id="${id}">Class: ${id}</button></p>`
                ).join('')}`
                : '';

            // Prix as buttons that trigger JS function
            const prixLinks = prixes.length
                ? `<h3>Prix</h3>${prixes.map(id =>
                    `<p><button class="swal-prix-btn" data-id="${id}">Prix: ${id}</button></p>`
                ).join('')}`
                : '';

            Swal.fire({
                title: "Duplication Successful!!",
                icon: "success",
                html: `
            ${tariffLinks}
            ${classLinks}
            ${prixLinks}
        `,
                showConfirmButton: true,
                allowOutsideClick: false, // prevent closing by clicking outside
                allowEscapeKey: false,    // prevent closing with ESC
                didOpen: () => {
                    // Add click handlers for Tariff
                    document.querySelectorAll('.swal-tariff-btn').forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            const id = e.target.getAttribute('data-id');
                            handleTariffClick(id); // call your function
                        });
                    });

                    // Add click handlers for Classes
                    document.querySelectorAll('.swal-class-btn').forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            const id = e.target.getAttribute('data-id');
                            handleClassClick(id); // call your function
                        });
                    });

                    // Add click handlers for Prix
                    document.querySelectorAll('.swal-prix-btn').forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            const id = e.target.getAttribute('data-id');
                            handlePrixClick(id); // call your function
                        });
                    });
                }
            });

            setShowDialog(false);
            setLoader(false);
            setBulkDuplicate(false);
            props?.tariffSearchApiCall();
        } else {
            setBulkUpdate(false);
            setShowDialog(false);
            setLoader(false);
            swal({
                text: response?.message,
                icon: "error",
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
        }


        console.log("payload", payload);
    }

    const handleTariffClick = (tariffId) => {
        window.open(`/newTariff?tariff=${tariffId}`, "_blank");
    }
    const handleClassClick = (classId) => {

        let tarif = classId?.slice(0, -3);
        window.open(`/newClass?tariff=${tarif}+&class=${classId}`, "_blank");
    }

    const handlePrixClick = (prixId) => {
        
        let classValue = prixId?.slice(0, -3);
        let tarifValue = classValue?.slice(0, -3);
        window.open(`/newPrix?tariff=${tarifValue}+&class=${classValue}+&prix=${prixId}`, "_blank");
    }

    return (
        <>
        {props?.isLoading ? <div className="col-md-12 text-center mt-3"><SpinnerLoader/> </div> : <>
        {responseTarifs.length  ? 
        <>
            <div className='ContractRes__BtnSection'>
            <div>
                {
                    (bulkUpdate || bulkDuplicate)
                        ? null
                        :
                        <Checkbox
                            name='allSelect'
                            onChange={(e) => handleChangeCheckbox(e, "allSelect", null)}
                            checked={(!props?.viewResultAsPrix && !props?.viewResultAsClass) ? (checkBoxObject['tarifs'].length == tarifKeys.length && checkBoxObject['classes'].length == classKeys.length && checkBoxObject['prixs'].length == prixKeys.length) : props?.viewResultAsClass ? (checkBoxObject['classes'].length == classKeys.length && checkBoxObject['prixs'].length == prixKeys.length) : (checkBoxObject['prixs'].length == prixKeys.length)}
                        />
                }
                <div style={{display: "flex", gap: "10px",}}>
                    {bulkDuplicate ?
                        <>
                            <Button className='Btn__BulkUpdate'>
                                Duplcating {viewValue}
                            </Button>
                        </>
                    :
                    
                        <>
                            <Button className='Btn__BulkUpdate' onClick={() => handleBulkUpdate(false)}>
                                Bulk Update
                            </Button>
                            <span>Duplicate</span>
                            <Button className='Btn__BulkUpdate' onClick={() => handleDuplicate("tariff")}>
                                Tariff
                            </Button>
                            <Button className='Btn__BulkUpdate' onClick={() => handleDuplicate("class")}>
                                Class
                            </Button>
                            <Button className='Btn__BulkUpdate' onClick={() => handleDuplicate("prix")}>
                                Prix
                            </Button>
                        </>
                    }
                </div>
                </div>
                            <div>
                                Total records:
                                {props?.viewResultAsPrix ?
                                    <>

                                        {prixKeys.length}
                                    </>
                                    :
                                    props?.viewResultAsClass ?
                                        <>
                                            {classKeys.length}
                                        </>
                                        :
                                        <>
                                            {responseTarifs.length}
                                        </>
                                }
                            </div>
                            {(!bulkUpdate)?<div className="col-md-6 text-right">
                                <button
                                    className="cm-secondary-btn mr-2"
                                    onClick={cancelBulkUpdate}
                                >
                                    x Cancel
                                </button>
                                <button
                                    className="cm-primary-btn"
                                    onClick={bulkUpdateForm}
                                    disabled={!(checkBoxObject['tarifs'].length || checkBoxObject['classes'].length || checkBoxObject['prixs'].length)}
                                >
                                    Next &gt; 
                                </button>

                            </div> : 
                            <Button className='Btn__Expandall'
                            onClick={handleExpandAll}
                           >
                               {exapandAllViewLabel}
                           </Button>
                            }
                            <div>
                                <select value={pageSize} onChange={handlePageSizeChange}>
                                    <option value={100}>100</option>
                                    <option value={125}>125</option>
                                    <option value={150}>150</option>
                                    <option value={175}>175</option>
                                    <option value={200}>200</option>
                                </select>
                            </div>
                
            </div>
            { paginationData.currentData().map((tarif,index)=>{
                return(<div className='contractRes__Box'>
                    {((bulkUpdate || props?.viewResultAsClass || props?.viewResultAsPrix) && (!bulkDuplicate || viewValue === "prix"))
                        ? null
                        : (
                            <Checkbox
                                className="contractRes__bluckU_Check"
                                name={tarif?.tarifKey}
                                onChange={(e) => handleChangeCheckbox(e, "tarif", tarif)}
                                checked={checkBoxObject['tarifs'].includes(tarif?.tarifKey)}
                            />
                        )
                    }

                    <Accordion className='contractResult_Accordion'
                        expanded={expanded.includes(String(tarif?.tarifKey))}  
                >
                    <AccordionSummary
                        aria-controls="panel1-content"
                        className='contactListResultAccordian'
                        id="panel1-header">
                        <div className="contractRes__Section">
                            <div className="contractRes__icon" onClick={handleIconClick(String(tarif?.tarifKey,expanded))}>
                                {(bulkUpdate || props?.viewResultAsClass || props?.viewResultAsPrix) && (!(bulkDuplicate && viewValue !== "prix")) ?   <img className="contractRes__img" src={ThreeDots}  /> : null}
                            </div>
                            <div className="contractRes__main" onClick={()=>onClickTarifDetails(tarif?.tarifKey)}>
                                <div className="contractRes__Left">
                                    <div className="contractRes__alert">
                                        <sapn>T</sapn>
                                    </div>
                                    <div>
                                    <img className="contractRes__img" src={getFlightLogo(tarif?.carrier)} alt='l' /> 
                                        <span className='contractRes_mainTitle'>{tarif?.carrier}</span>
                                        <span className='contractRes_bar'>|</span>
                                        <span className='contractRes_subTitle'> VIA:</span>
                                        <span className='contractRes_mainTitle'> {tarif?.via}</span>
                                    </div>
                                    <div className='Origin'>
                                        <span className='contractRes_subTitle'>  Origin:</span>
                                        <Tooltip placement='top' title={tarif?.origins}><span className='contractRes_mainTitle'> {getOriginDestination(tarif?.origins)}</span></Tooltip>
                                    </div>
                                    <div >
                                        <span className='contractRes_subTitle'> Destinations: </span>
                                        <Tooltip placement='top' arrow title={tarif?.destinations}><span className='contractRes_mainTitle'> {getOriginDestination(tarif?.destinations)}</span></Tooltip>
                                    </div>
                                </div>
                                <div className="ContractRes__Right">
                                    <span className='contractRes_mainTitle contractRes_BrandFare'> {tarif?.isBrandedFare? "Branded Fare":"Non-Branded Fare"}</span>
                                    <span className='contractRes_subTitle' >Note: </span>
                                    <span className='contractRes_mainTitle'> {tarif?.note}</span>
                                </div>
                            </div>
                        </div>
                    </AccordionSummary>
                    { (tarif?.classes).map((classValue,Innindex)=>{
                        return (<div className='contractRes__Box'>
                            {(bulkUpdate || !props?.viewResultAsClass) && (!bulkDuplicate || viewValue === "tarif")
                                ? null
                                : <Checkbox className="contractRes__bluckU_Check" name={classValue?.clasKey} onChange={(e) => handleChangeCheckbox(e, "class", classValue)} checked={checkBoxObject['classes'].includes(classValue?.clasKey) || false} />
                            }
                        <AccordionDetails >
                        <Accordion
                                       expanded={innExpanded.includes(String(classValue?.clasKey))}

                        >
                            <AccordionSummary
                                aria-controls="contractRes_childFirst"
                                id="contractRes_childFirst"
                            >
                                <div className="contractRes__Section  contractRes_childFirst">
                                    <div className="contractRes__icon" onClick={handleInnIconClick(String(classValue?.clasKey))}>
                                    {(bulkUpdate || !props?.viewResultAsClass) && (!(bulkDuplicate && viewValue !== "tarif")) ? <img className="contractRes__img" src={TwoDots}  /> : null }
                                    </div>
                                    <div className="contractRes__main" onClick={()=>{openClass(classValue,tarif)}}>
    
                                        <div className="contractRes__Left">
                                            <div className="contractRes__alert">
                                                <sapn>C</sapn>
                                            </div>
                                            <div className='contractRes_childRight'>
                                                <div className='contractRes_classesOfC'>
                                                    <span className='contractRes_mainTitle'> Type:</span>
                                                    <span className='contractRes_mainTitle'> {classValue?.contractType}</span>
                                                </div>
                                                <div className='contractRes_classesOfC'>
                                                    <span className='contractRes_subTitle'>  Classes: </span>
                                                    <span className='contractRes_mainTitle' title={classValue?.classCodes?.join(',')}> {classValue?.classCodes?.join(',')}</span>
                                                </div>
                                                <div className='contractRes_classesOfC'>
                                                    <span className='contractRes_subTitle'> Brand: </span>
                                                    <span className='contractRes_mainTitle'>{classValue?.brandCode}</span>
                                                </div>
                                                <div className='contractRes_classesOfC'>
                                                    <span className='contractRes_subTitle'> Category: </span>
                                                    <span className='contractRes_mainTitle'>{classValue?.category}</span>
                                                </div>
                                                <div className='contractRes_classesOfC'>
                                                    <span className='contractRes_subTitle'> EDR:</span>
                                                    <span className='contractRes_mainTitle'> {classValue?.classLastTicketingDate ? format(parseISO(new Date(classValue?.classLastTicketingDate).toISOString().split('T')[0]), 'dd MMM yyyy') : ''}</span>
                                                </div>
                                                <div className='contractRes_classesOfC'>
                                                    <span className='contractRes_subTitle'>Note: </span>
                                                    <span className='contractRes_mainTitle'>{classValue?.classNote}</span>
                                                </div>
                                                <div className='contractRes_classesOfC'>
                                                    <span className='contractRes_subTitle'> Source:</span>
                                                    <span className='contractRes_mainTitle'>  {classValue?.classCodeDesc}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </AccordionSummary>
                            {classValue?.prix.map((prixValue, index)=>{
                                return(<div className='contractRes__Box'>
                                    {(bulkUpdate || !props?.viewResultAsPrix) && (!bulkDuplicate || viewValue === "tarif")
                                    ? null 
                                    : <Checkbox className="contractRes__bluckU_Check" name={prixValue?.prixKey} onChange={(e)=>handleChangeCheckbox(e,"prix",prixValue)} checked={checkBoxObject['prixs'].includes(prixValue?.prixKey) || false} />}
                                    <AccordionDetails>
                                <div className="contractRes__Section  contractRes_childSecnd">
                                    <div className="contractRes__icon">
                                    {(bulkUpdate || !props?.viewResultAsPrix) && (!(bulkDuplicate && viewValue !== "tarif")) ? <img className="contractRes__img" src={bluedot}  /> : null} 
                                    </div>
                                    <div className="contractRes__main" style={{"cursor":"pointer"}} onClick={()=>prixDetailsOnclick(prixValue?.prixKey, classValue, tarif)}>
    
                                        <div className="contractRes__Left">
                                            <div className="contractRes__alert">
                                                <sapn>p</sapn>
                                            </div>
                                            <div className='contractRes_childRight'>
                                                <div>
                                                    <span className='contractRes_mainTitle'> Validity: </span>
                                                    <span className='contractRes_mainTitle'>
                                                        {`${moment.utc(prixValue?.validFrom).format("DD-MMM-yyyy")} to ${moment.utc(prixValue?.validTo).format("DD-MMM-yyyy")}`}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span className='contractRes_subTitle'> Our Comm:</span>
                                                    <span className='contractRes_mainTitle'>  {prixValue?.commissionPercentage} </span>
                                                </div>
                                                <div>
                                                    <span className='contractRes_subTitle'> Agency Comm:  </span>
                                                    <span className='contractRes_mainTitle'>{prixValue?.passBackCommission}</span>
                                                </div>
                                                <div>
                                                    <span className='contractRes_subTitle'> Markup:  </span>
                                                    <span className='contractRes_mainTitle'>{prixValue?.markup}</span>
                                                </div>
                                                <div>
                                                    <span className='contractRes_subTitle'> Tour Code:</span>
                                                    <span className='contractRes_mainTitle'>  {prixValue?.tourCode?.[0]?.tourCodes}</span>
                                                </div>
    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                                </div>)
                            })}
                            
                        </Accordion>
                    </AccordionDetails>
                        </div>)
                    })
                    
                        }
                </Accordion>
                </div>)
            })   
            }
            <Pagination
            count={count}
            size="large"
            page={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
        />
        </>
        :
        null       
        }
    </>}
        <Dialog
            open={showDialog}
            onClose={() => cancelBulkUpdate()}
            aria-labelledby="form-dialog-title"
            maxWidth="md"
            fullWidth

        >
            <DialogTitle id="form-dialog-title">Duplicate {viewValue}</DialogTitle>
            <DialogContent>

                {viewValue === "tarif" ?
                    <>
                        <div className="row">
                            <div className="col-md-3">
                                <label className="cm-head-label">Origin</label>

                                <input
                                    className="form-control cm-input"
                                    placeholder="Enter Origin ..."
                                    value={originValue}
                                    name="originValue"
                                    onChange={(e) => setOriginValue(e.target.value.toUpperCase())}
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="cm-head-label">Destination</label>
                                <input
                                    className="form-control cm-input"
                                    placeholder="Enter Destination ..."
                                    name="destinationValue"
                                    value={destinationValue}
                                    onChange={(e) => setDestinationValue(e.target.value.toUpperCase())}
                                />
                            </div>
                        </div>
                    </>
                    :
                    viewValue === "class" ?
                        <>
                        </>
                        :
                    <>
                        <div className="row">
                            <div className="col-md-3">
                                <label className="cm-head-label">Valid From</label>

                                <CustomDateInput
                                    value={validFrom || ''}
                                    name="validFrom"
                                    onChange={(e) => setValidFrom(e)}
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="cm-head-label">Valid To</label>&nbsp;&nbsp;

                                <CustomDateInput
                                    value={validTo || ''}
                                    name="validTo"
                                    onChange={(e) => setValidTo(e)}
                                />
                            </div>
                        </div>
                    </>
                }
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <div>
                        Are you sure you want to duplicate selected {viewValue} ?
                        <div style={{ display: "flex", justifyContent: "space-evenly", marginTop: "20px" }}>
                            <button className='cm-primary-btn' onClick={()=>handleBulkDuplicate()}>
                                {loader && <span className="mr-5 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                Confirm
                            </button>
                            <button className='cm-secondary-btn mr-2' onClick={()=>cancelBulkUpdate()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </DialogContent>


        </Dialog>
        </>
    );
}
